export default {
  name: 'matrix',

  anchor: '#1034a6',
  anchorVisited: '#440381',
  borderDark: '#282828',
  borderDarkest: '#000000',
  borderLight: '#656565',
  borderLightest: '#a7a7a7',
  canvas: '#c0c0c0',
  canvasText: '#000000',
  canvasTextDisabled: '#282828',
  canvasTextDisabledShadow: '#ff0000',
  canvasTextInvert: '#ffffff',
  checkmark: '#000000',
  checkmarkDisabled: '#282828',
  flatDark: '#9e9e9e',
  flatLight: '#d8d8d8',
  focusSecondary: '#35FF69',
  headerBackground: '#000000',
  headerNotActiveBackground: '#7f7f7f',
  headerNotActiveText: '#535353',
  headerText: '#a7a7a7',
  hoverBackground: '#000000',
  material: '#535353',
  materialDark: '#282828',
  materialText: '#35FF69',
  materialTextDisabled: '#282828',
  materialTextDisabledShadow: '#a7a7a7',
  materialTextInvert: '#ffffff',
  progress: '#000000',
  tooltip: '#fefbcc'
};
